import React, { useState} from 'react';
import { MODALS } from '../../../../config/images';
const BillingObs = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  title
}) => {
  const [observationText, setObservationText] = useState('');

  const MAX_DESCRIPTION_LENGTH = 500;

  const handleSubmit = () => {
    if (observationText.trim()) {
      onSubmit(observationText);
      setObservationText(''); 
    }
  };

  const handleClose = () => {
    setObservationText('');
    onClose();
  };

  const handleObservationChange = (e) => {
    const inputText = e.target.value;
    if (inputText.length <= MAX_DESCRIPTION_LENGTH) {
      setObservationText(inputText);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[30%] p-4 bg-white rounded-[29px]">
        <div className="flex justify-end w-full ">
            <button
              onClick={handleClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <img src={MODALS.CLOSE} alt="cerrar"/>
            </button>
        </div>

        <div className='flex flex-col gap-3 px-6'>
            <div className='flex items-center justify-between'>

              <p className="text-sm font-itcdemi">
                  {title} <span className="text-red-500">*</span>
              </p>

              <span className={`text-xs ${observationText.length >= MAX_DESCRIPTION_LENGTH ? 'text-red-500' : 'text-gray-500'}`}>
                {observationText.length}/{MAX_DESCRIPTION_LENGTH}
              </span>
            </div>
              
            <textarea
                value={observationText}
                onChange={handleObservationChange}
                placeholder="Describa"
                className="w-full h-[125px] p-3 border text-[13px] border-1 border-[#D1D5DB] rounded-md focus:outline-none  font-itcbook"
            />
            {observationText.length >= MAX_DESCRIPTION_LENGTH && (
              <p className="text-xs text-red font-itcbook">Has alcanzado el límite máximo de caracteres</p>
            )}
        </div>
        <div className='flex items-center justify-center'>
            <button
                onClick={handleSubmit}
                disabled={!observationText.trim()}
            className={`px-4 py-2 text-[15px] font-itcbook underline ${
              observationText.trim() 
                ? 'text-blue cursor-pointer' 
                : 'text-gray-400 cursor-not-allowed'
            }`}
            >
                Enviar
            </button>
        </div>
      </div>
    </div>
  );
};

export default BillingObs;